/** The site title template and the dynamic-page name token. Pure. */

export const TITLE_PAGE_TOKEN = '{page}';
export const NAME_TOKEN = '{{NAME}}';

const replaceEvery = (text: string, token: string, value: string): string => text.split(token).join(value);

/** The page title through the site template; the page alone without one. */
export const applyTitleTemplate = (template: string | undefined, page: string): string =>
  template ? replaceEvery(template, TITLE_PAGE_TOKEN, page) : page;

export const templateHasPageToken = (template: string): boolean => template.includes(TITLE_PAGE_TOKEN);

/** A dynamic page's template with every `{{NAME}}` replaced by `sample` (the preview's "Game name"). */
export const sampleName = (text: string, sample: string): string => replaceEvery(text, NAME_TOKEN, sample);
